module.exports = __webpack_public_path__ + "components/carousel-nearby-mountains/static/generic-bg--1-f0c307233711d3833a7c53e6ab1ca1bf.jpg";